/* global modForm Modalytics */
import { getCurrentStep, showNextStep, unmarkFieldAsInvalid } from '../../../helpers';
import { isFormValid } from '../../../validators';

/**
 * Handles show/hide of the extra question block
 * @param {HTMLInputElement} $radio - The radio input element that was clicked
 */
export function initExtraQuestionBlock($radio) {
	const $activeStep = getCurrentStep(),
		oneWindowSelectedClass = 'step--one-window-selected';

	function checkExtraQuestionTrigger(radioButton, checkValue = false) {
		return modForm.opts.extraQuestionBlockTriggers.some(trigger => {
			if (checkValue) {
				return radioButton.name === trigger.name && radioButton.value === trigger.value;
			}
			return radioButton.name === trigger.name;
		});
	}

	if (!modForm.opts.formSwiperInstance || !modForm.opts.formSwiperInstance?.animating) {
		if (modForm.opts.extraQuestionBlock && checkExtraQuestionTrigger($radio)) {
			if (checkExtraQuestionTrigger($radio, true)) {
				modForm.opts.extraQuestionBlock.style.display = 'block';
				modForm.opts.extraQuestionInputs.forEach(($input) => {
					if ($input) {
						$input.setAttribute('data-required', 'nonempty');
					}
				});
				if ($radio.name === 'NumberOfWindows') {
					$activeStep.classList.add(oneWindowSelectedClass);
					Modalytics.heap('track', ['Open To Multiple Windows | Question Shown']);
				}
				if (modForm.opts.formSwiperInstance.params.autoHeight === true) {
					modForm.opts.formSwiperInstance.updateAutoHeight();
				}
			} else {
				modForm.opts.extraQuestionBlock.style.display = 'none';
				modForm.opts.extraQuestionInputs.forEach(($input) => {
					if ($input) {
						$input.checked = false;
						$input.removeAttribute('data-required');
					}
				});
				unmarkFieldAsInvalid(modForm.opts.extraQuestionInputs[0]);
				if ($radio.name === 'NumberOfWindows') {
					$activeStep.classList.remove(oneWindowSelectedClass);
				}
				if (modForm.opts.formSwiperInstance.params.autoHeight === true) {
					modForm.opts.formSwiperInstance.updateAutoHeight();
				}
				if (!isFormValid($activeStep)) {
					return;
				}
				showNextStep();
			}
		} else {
			if ($radio.name === 'MultipleWindows') {
				Modalytics.heap('track', [`Open To Multiple Windows | Clicked Option ${$radio.value}`]);
			}
			if (!isFormValid($activeStep)) {
				return;
			}
			showNextStep();
		}
	}
}
